// The calendar team filter, kept locally (per browser). Empty = show every team.
const KEY = "messe.teamFilter";

export function getTeamFilter(): string {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function setTeamFilter(id: string): void {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
